import React from 'react';
import PropTypes from 'prop-types';
import {
  MenuItem,
  Select,
  TextField,
  Calendar,
  DateUtils,
} from 'mw-style-react';
import FormUtils from '@control-front-end/utils/formUtils';
import AutocompleteSources from '@control-front-end/common/components/AutocompleteSources';
import '../../../../ActorsFiltersPopup.scss';
import { DATE_FORMAT_2 } from 'constants';
import useIntl from 'useIntl';
import mes from './intl';

/**
 * Поле выбора значения для поля фильтра
 */
function FieldValue({
  id,
  index,
  value: fieldValue,
  form,
  formId,
  formItems,
  handleChangeField,
}) {
  const field = formItems.find((item) => id.indexOf(item.id) === 0);
  const t = useIntl();
  const checkboxValues = [
    { value: 'true', title: t(mes.checkboxTrue) },
    { value: 'false', title: t(mes.checkboxFalse) },
  ];

  const handleChangeDate = ({ value }) => {
    const date = DateUtils.startOf(value.startDate * 1000, 'day');
    const unixtimeValue = DateUtils.dateToUnixtime(date);
    handleChangeField({
      id: `value_${index}`,
      value: unixtimeValue.toString(),
      addParam: 'startDate',
    });
  };
  const showTextField = (value, calendar) => (
    <TextField
      id={`value_${index}`}
      styleName="filters__popup__content__textfield"
      size="medium"
      bordered={true}
      value={value}
      onChange={handleChangeField}
      calendar={calendar}
    />
  );
  const showCalendar = () => (
    <Calendar
      id="from"
      styleName="filters__popup__content__calendar"
      size="small"
      onChange={handleChangeDate}
    />
  );
  const showSelect = (value, options) => (
    <Select
      id={`value_${index}`}
      styleName="filters__popup__content__select"
      type="autocomplete"
      size="medium"
      bordered={true}
      value={value}
      onChange={handleChangeField}
    >
      {options.map((item) => (
        <MenuItem key={item.value} value={item.value} label={item.title} />
      ))}
    </Select>
  );

  if (!field) return showTextField(fieldValue, null);
  if (field.options) {
    const { extra = {}, valueTitle = [] } = field;
    const hasOptionsSource =
      extra.optionsSource && extra.optionsSource.type !== 'manual';
    if (hasOptionsSource) {
      return (
        <AutocompleteSources
          key={id}
          styleType="small"
          portal={false}
          id={id}
          formId={formId}
          valueTitle={valueTitle}
          value={fieldValue}
          loadInitValue={true}
          getFormData={() => FormUtils.getFormData(form)}
          onChange={(d) => {
            handleChangeField({
              id: `value_${index}`,
              value: d.value[0].value,
            });
          }}
        />
      );
    }
    return showSelect(
      fieldValue ? fieldValue.toString() : fieldValue,
      field.options
    );
  }
  switch (field.class) {
    case 'calendar':
      return showTextField(
        DateUtils.toDate(fieldValue, DATE_FORMAT_2),
        showCalendar
      );
    case 'check':
      return showSelect(fieldValue, checkboxValues);
    default:
      return showTextField(fieldValue, null);
  }
}

FieldValue.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  form: PropTypes.object,
  formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.string,
  index: PropTypes.number,
  formItems: PropTypes.array,
  handleChangeField: PropTypes.func,
};

export default FieldValue;
